/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Distillation_Error_No_Personal_SpaceInputs */



/**
* | output |
* | --- |
* | "Personal space not available" |
*
* @param {Distillation_Error_No_Personal_SpaceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const distillation_error_no_personal_space = /** @type {((inputs?: Distillation_Error_No_Personal_SpaceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Distillation_Error_No_Personal_SpaceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Persönlicher Bereich nicht verfügbar")
	return /** @type {LocalizedString} */ ("Personal space not available")
});